import { GOOGLE_ID } from "../../Constants";
import React, { useEffect } from "react";
import { Route, Switch, useLocation } from "react-router-dom";
import NewEnquiry from "./NewEnquiry/NewEnquiry";
import TrucksAvailable from "./TrucksAvailable";
import AdhocDash2 from "./AdhocDashboard/SpotDashboard";
import DraftEnquiries from "./DraftEnquiries/DraftEnquiries";
import DraftDetailPage from "./DraftEnquiries/DraftDetailPage";
import Adhocdash2 from "./AdhocDashboard/SpotDashboard";
import ReactGA from "react-ga4";

// Google Analytics tracking ID
const gaId = GOOGLE_ID;
ReactGA.initialize(gaId);

/**
 * Component responsible for routing within the Trucks section of the application.
 * It tracks page views using Google Analytics and defines routes for specific pages.
 *
 * @component
 * @returns {React.ReactElement} The routing component for the Trucks section.
 */
const TrucksRoute = () => {
  const location = useLocation(); // Get the current location using useLocation from react-router-dom

  /**
   * Sends a page view hit to Google Analytics whenever the location changes.
   * This effect runs on every location change.
   *
   * @function
   */
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: location.pathname });
  }, [location]);

  return (
    <Switch>
      {/* Route for the Trucks dashboard component */}
      <Route path="/trucks/dashboard" component={AdhocDash2} exact />
      {/* Route for the New Enquiry component */}
      <Route path="/trucks/enquiries" component={NewEnquiry} exact />
      {/* Route for the Trucks Available component */}
      <Route
        path="/trucks/transporterenquiries"
        component={TrucksAvailable}
        exact
      />
      {/* Route for the Draft detail page */}
      <Route path="/trucks/drafts/:draft_id" component={DraftDetailPage} />
      {/* Route for the Draft Enquiries component */}
      <Route path="/trucks/drafts" component={DraftEnquiries} exact />
    </Switch>
  );
};

export default TrucksRoute;
